import * as SC from "./styles";

export const PingIndicator = () => {
    return <SC.Ping data-automation="ping-indicator" />;
};
